module.exports = new __parcel__URL__("paralyticarrow.9dc04320.png").toString();